export const menuData = [
  {
    category: { en: "Starters & Bites", fr: "Entrées & Bouchées" },
    items: [
      { 
        name: { en: "Classic Nachos", fr: "Nachos Classiques" }, 
        desc: { en: "Loaded with cheese, jalapeños, sour cream, and salsa.", fr: "Garnis de fromage, jalapeños, crème sure et salsa." }, 
        price: "$14", 
        popular: true 
      },
      { 
        name: { en: "Chicken Wings", fr: "Ailes de Poulet" }, 
        desc: { en: "1lb tossed in your choice of Buffalo, BBQ, or Honey Garlic.", fr: "1lb servie avec sauce Buffalo, BBQ ou Miel et Ail." }, 
        price: "$16", 
        popular: true 
      },
      { 
        name: { en: "Mozzarella Sticks", fr: "Bâtonnets de Mozzarella" }, 
        desc: { en: "Served with warm marinara dipping sauce.", fr: "Servis avec une sauce marinara chaude." }, 
        price: "$10" 
      },
      { 
        name: { en: "Onion Rings", fr: "Rondelles d'Oignon" }, 
        desc: { en: "Crispy thick-cut rings with spicy mayo.", fr: "Rondelles croustillantes avec mayo épicée." }, 
        price: "$9" 
      },
    ]
  },
  {
    category: { en: "Mains", fr: "Plats Principaux" },
    items: [
      { 
        name: { en: "The 8-Ball Burger", fr: "Le Burger 8-Ball" }, 
        desc: { en: "Double patty, cheddar, bacon, caramelized onions, house sauce.", fr: "Double galette, cheddar, bacon, oignons caramélisés, sauce maison." }, 
        price: "$18", 
        popular: true 
      },
      { 
        name: { en: "Crispy Chicken Sandwich", fr: "Sandwich au Poulet Croustillant" }, 
        desc: { en: "Fried chicken breast, pickles, slaw, brioche bun.", fr: "Poitrine de poulet frit, cornichons, salade de chou, pain brioché." }, 
        price: "$17" 
      },
      { 
        name: { en: "Poutine Classic", fr: "Poutine Classique" }, 
        desc: { en: "Fries, fresh cheese curds, rich brown gravy.", fr: "Frites, fromage en grains frais, sauce brune riche." }, 
        price: "$12" 
      },
      { 
        name: { en: "Margherita Pizza", fr: "Pizza Margherita" }, 
        desc: { en: "Fresh basil, mozzarella, house tomato sauce.", fr: "Basilic frais, mozzarella, sauce tomate maison." }, 
        price: "$15" 
      },
    ]
  },
  {
    category: { en: "Draft & Bottles", fr: "Fûts & Bouteilles" },
    items: [
      { 
        name: { en: "Local Draft Pint", fr: "Pinte de Fût Locale" }, 
        desc: { en: "Ask about our rotating local taps.", fr: "Demandez nos sélections locales du moment." }, 
        price: "$7" 
      },
      { 
        name: { en: "Imported Bottles", fr: "Bouteilles Importées" }, 
        desc: { en: "Corona, Heineken, Stella Artois.", fr: "Corona, Heineken, Stella Artois." }, 
        price: "$8" 
      },
      { 
        name: { en: "Craft IPA", fr: "IPA Artisanale" }, 
        desc: { en: "Hops-forward, citrus notes, refreshing.", fr: "Houblonnée, notes d'agrumes, rafraîchissante." }, 
        price: "$9", 
        popular: true 
      },
    ]
  }
];